import { ILogoTheme } from './types';

export const theme: ILogoTheme = {
  reversedColor: false,
  height: 'full',
};
